import { authedJson } from '../http';

export interface CalibrationBand {
  n: number;
  wins: number;
  win_rate: number | null;
  posterior: number | null;
  status?: string;
  source?: string;
}
export interface CalibrationResponse {
  global: CalibrationBand & { status: string };
  themes: Record<string, CalibrationBand & { source: string }>;
  any_cap_active: boolean;
}
export function getCalibration(): Promise<CalibrationResponse> {
  return authedJson('GET', '/api/v1/calibration');
}
